<template>
  <section>
    <v-table
      url="/api/v1/dialog/waiting-dialogs"
      :attributes="[
        {
          attribute: 'ins_for_moderator.user',
          name: 'Letzter Moderator',
          type: 'UserNoEmailCell',
          sortable: false
        },
        {
          attribute: 'customer',
          name: 'Mitglied',
          type: customerCell,
          sortable: false
        },
        {
          attribute: 'fake',
          name: 'Fake',
          type: 'LinkProfileCell',
          sortable: false
        },
        {
          attribute: 'dialog_id',
          name: 'Dialog',
          type: 'DialogInfoCell',
          sortable: false
        },
        {
          attribute: 'last_message_at',
          name: 'In Warteschlange seit',
          type: 'TimeCounterCell'
        },
        {
          name: 'Aktionen',
          type: 'WaitingDialogActionCell'
        }
      ]"
      ref="table"
      @table-fetched="tableFetched"
    >
      <div slot="title">
        Warteschlange der Nachrichten
      </div>
    </v-table>
  </section>
</template>

<script lang="babel">
export default {
  data() {
    return {
      fetchInterval: null,
      canFetch: true,
    }
  },
  mounted() {
    this.$bus.$on("waiting-dialogs-update", () => this.fetch());

    this.fetchInterval = setInterval(() => {
      this.fetch();
    }, 3500);
    this.fetch();
  },
  beforeDestory() {
    clearInterval(this.fetchInterval);
  },
  methods: {
    fetch() {
      if (this.canFetch && this.$refs.table) {
        this.canFetch = false;
        this.$refs.table.fetch().finally(() => this.canFetch = true);
      }
    },
    tableFetched() {
      this.$emit("count-update", this.$refs.table.count);
    }
  },
  computed: {
    customerCell() {
       return Laravel.user.roles.some(el => el.name === "agency_leader") ?
          'CustomerCell' : 'LinkProfileCell';
    },
  },
};
</script>
